import { SharepointItem } from "@/modules/sharepoint/types";
import { baseApi } from "@/api/baseApi";
import { SHAREPOINT_TAGS } from "./sharepoint.constraints";

interface SharepointQueryParams {
  mode?: string;
  site_id?: string;
  drive_id?: string;
  folder_id?: string;
}

export const sharepointApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getSharepointItems: builder.query<
      {
        status: "login_required" | "success";
        items: SharepointItem[];
        navigation: {
          mode: string;
          site_id: string | null;
          drive_id: string | null;
          folder_id: string | null;
          breadcrumbs: Array<{ label: string; params: Record<string, string> }>;
        };
      },
      SharepointQueryParams | void
    >({
      providesTags: [SHAREPOINT_TAGS.SHAREPOINT_TAG],
      query: params => ({
        url: "/pf-mainweb/document/sharepoint",
        params: params || { mode: "menu" },
      }),
    }),
  }),
});

export const { useGetSharepointItemsQuery } = sharepointApi;
